import React, { useState } from "react";
const EircodeUndervaluedChart = ({ data }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(data.length / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  const paginationStyle = {
    display: "flex",
    flexWrap: "wrap",
    gap: "5px",
    listStyle: "none",
    padding: "10px",
  };

  const buttonStyle = {
    margin: "0 2px",
    border: "1px solid #ddd",
    background: "#f4f4f4",
    borderRadius: "5px",
    padding: "5px 5px",
    cursor: "pointer",
  };

  const selectedButtonStyle = {
    ...buttonStyle,
    background: "#007bff",
    color: "#fff",
    border: "1px solid #007bff",
  };

  return (
    <div>
      <h2>Asking vs sale price by routing key</h2>
      Average reported asking-to-sale percentage difference for matched
      properties in each routing key. Positive values mean sale prices above
      asking; this is not a valuation.
      <table>
        <thead>
          <tr>
            <th>Routing Key</th>
            <th>Average difference (%)</th>
            <th>Count</th>
          </tr>
        </thead>
        <tbody>
          {currentItems.map((row) => (
            <tr key={row._id}>
              <td>{row._id}</td>
              <td>
                {typeof row.undervalued_percent === "number"
                  ? row.undervalued_percent.toFixed(2)
                  : "Unavailable"}
              </td>
              <td>{row.count}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <nav>
        <ul style={paginationStyle}>
          {pageNumbers.map((number) => (
            <li key={number}>
              <button
                style={
                  currentPage === number ? selectedButtonStyle : buttonStyle
                }
                onClick={() => paginate(number)}
              >
                {number}
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default EircodeUndervaluedChart;
